import React, { FC, useMemo, useState } from 'react'
import { VStack, Image, Box, Checkbox, HStack, Flex } from '@chakra-ui/react'
import { InputDefault } from './input-default'
import { cardImageMap, Steps } from '../../state/interfaces'
import { useTranslation } from 'react-i18next'
import { addAnswer, selectCurrentStep, selectScenarioId, useSelector } from '../../state'
import { useDispatch } from 'react-redux'

export interface InputPhoneNumberProps {
  placeholder?: string
  onChange?: (values: string[]) => void
  name: string
  grandImage?: string
}

export const InputPhoneNumber: FC<InputPhoneNumberProps> = ({ placeholder, onChange, name, grandImage }) => {
  const image = useMemo(() => (grandImage ? cardImageMap[grandImage] : ''), [grandImage])
  const [keepNumber, setKeepNumber] = useState(false)
  const { t } = useTranslation()
  const scenarioId = useSelector(selectScenarioId)
  const currentStep = useSelector(selectCurrentStep)
  const dispatch = useDispatch()

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setKeepNumber(e.target.checked)
  }

  const onSubmit = (values: string[]) => {
    if (currentStep?.id === Steps.PHONE_RESIDENTIAL) {
      if (keepNumber) {
        dispatch(addAnswer({ stepId: Steps.KEEP_CURRENT_NUMBER, answerIds: ['yes'], hidden: true }))
        onChange && onChange([...values])
      } else {
        dispatch(addAnswer({ stepId: Steps.KEEP_CURRENT_NUMBER, answerIds: ['no'], hidden: true }))
        onChange && onChange(values)
      }
    } else {
      onChange && onChange(values)
    }
  }

  const handleOnChange = (values: string[]) => {
    if (scenarioId === 'lead-internet-mektel') {
      onSubmit(values)
    } else {
      onChange && onChange(values)
    }
  }

  return (
    <VStack spacing={3} gridRowGap={4}>
      <InputDefault placeholder={placeholder} onChange={handleOnChange} inputType="phone" name={name} />

      {scenarioId === 'lead-internet-mektel' && Steps.PHONE_RESIDENTIAL === currentStep?.id && (
        <Box borderWidth="1px" borderRadius="md" p={4} width="100%" borderColor={'gray'}>
          <HStack spacing={4}>
            <Flex
              border="4px solid lightgrey"
              overflow="hidden"
              alignItems="center"
              mt={1}
              minW={'18px'}
              zIndex={2}
              borderRadius={'full'}
            >
              <Checkbox
                isChecked={keepNumber}
                onChange={handleCheckboxChange}
                colorScheme="blue"
                sx={{
                  '.chakra-checkbox__control': {
                    bg: 'gray.200',
                    borderColor: 'gray.300',
                  },
                }}
              />
            </Flex>
            <span>{t('keep-current-number')}</span>
          </HStack>
        </Box>
      )}

      {image && <Image src={image} alt="image" width={['200px', '250px']} height={['200px', '250px']} />}
    </VStack>
  )
}
